module.exports = __webpack_public_path__ + "static/media/D.1b5b16b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/D.svg
// module id = 288
// module chunks = 0